import { render, staticRenderFns } from "./ProductSwatches.vue?vue&type=template&id=3c960699&scoped=true"
import script from "./ProductSwatches.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductSwatches.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductSwatches.vue?vue&type=style&index=0&id=3c960699&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c960699",
  null
  
)

export default component.exports